export default function StepNavigation({ currentStep, completedSteps = [] }) {
  const steps = [
    { id: 1, label: "Topic" },
    { id: 2, label: "Script" },
    { id: 3, label: "Scenes" },
    { id: 4, label: "Preview" },
    { id: 5, label: "Assets", hidden: true },
    { id: 6, label: "Editor" },
  ].filter(s => !s.hidden).map((s, i) => ({ ...s, displayNum: i + 1 }));

  return (
    <nav className="flex items-center justify-center gap-1 sm:gap-2 overflow-x-auto">
      {steps.map((step, index) => {
        const isCompleted = completedSteps.includes(step.id);
        const isCurrent = currentStep === step.id;
        const isPast = step.id < currentStep;

        return (
          <div key={step.id} className="flex items-center">
            <div className="flex items-center gap-1.5 sm:gap-2">
              {/* Step circle */}
              <span
                aria-label={`${step.label}${isCompleted ? " (completed)" : isCurrent ? " (current)" : ""}`}
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold transition-all flex-shrink-0 ${
                  isCompleted
                    ? "bg-primary-500 text-white"
                    : isCurrent
                    ? "bg-primary-100 text-primary-700 ring-2 ring-primary-500 ring-offset-1"
                    : "bg-gray-100 text-gray-400"
                }`}
              >
                {isCompleted ? (
                  <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  step.displayNum
                )}
              </span>
              {/* Step label — abbreviated on mobile, full on sm+ */}
              <span
                className={`text-xs sm:text-sm font-medium transition-colors whitespace-nowrap ${
                  isCurrent
                    ? "text-primary-600"
                    : isCompleted || isPast
                    ? "text-gray-600"
                    : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </div>
            {/* Connector line */}
            {index < steps.length - 1 && (
              <div className={`w-6 sm:w-10 h-0.5 mx-1 sm:mx-2 rounded-full transition-colors ${
                isCompleted || isPast ? "bg-primary-300" : "bg-gray-200"
              }`} />
            )}
          </div>
        );
      })}
    </nav>
  );
}
